import { Button, Col, Container, Form, Row } from "react-bootstrap";
import DependantHeaderSample from "../common/dependantHeaderSample";
import { useEffect, useState } from "react";
import { URL, labsDetails, platform } from "../../constants/constant";
import axios from "axios";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { Backdrop, CircularProgress } from "@mui/material";

const Checkout = () => {
  const userName = localStorage.getItem("userName");
  const selectedBenef = JSON.parse(localStorage.getItem("selectedBenef"));
  const cart = JSON.parse(localStorage.getItem("cart"));
  const parentOrderDetails = localStorage.getItem("parentOrderDetails") ? JSON.parse(localStorage.getItem("parentOrderDetails")) : null;
  const [pincode, setPincode] = useState(parentOrderDetails.pincode ? parentOrderDetails.pincode : "");
  const [city, setCity] = useState(parentOrderDetails.city ? parentOrderDetails.city : "");
  const [addressLine1, setAddressLine1] = useState(parentOrderDetails.addressLine1 ? parentOrderDetails.addressLine1 : "");
  const [addressLine2, setAddressLine2] = useState(parentOrderDetails.addressLine2 ? parentOrderDetails.addressLine2 : "");
  const [email, setEmail] = useState(parentOrderDetails.email ? parentOrderDetails.email : "");
  const [phone, setPhone] = useState(parentOrderDetails.phoneNumber ? parentOrderDetails.phoneNumber : "");
  const [orderDateTime, setOrderDateTime] = useState(parentOrderDetails.orderDateTime ? new Date(parentOrderDetails.orderDateTime).toISOString() : "");
  const [providerSlots, setProviderSlots] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [timeSlots, setTimeSlots] = useState([]);
  const history = useHistory();
  const [isLoading, setLoading] = useState();

  labsDetails.checkoutInfo = {};

  labsDetails.walletVerified = false;
  
  labsDetails.uploadedFiles = [];

  const fetchProviderCalendar = () => {
    let accessToken = localStorage.getItem("user_short_token");
    let providerId = parseInt(localStorage.getItem("selectedProviderId"));
    let url = URL.mb_wapi + "Labs/ProvidersCalendar";
    let packageIds = cart.map((elem) => elem.packageId);
    let obj = {
      providerIds: [providerId],
      noOfDays: "30",
      isHomeVisitCase: true,
      packageIds: packageIds,
      contractId: 10386,
      noOfSlots: 1,
    };
    let headers = {
      Accesstoken: accessToken,
      Platform: platform,
      pincode: pincode,
      city: city,
    };
    axios.post(url, obj, { headers: headers }).then(function (response) {
      if (response.data.isSuccess) {
        setProviderSlots(response.data.providerSlots[0].daySlots);
        let date = response.data.providerSlots[0].daySlots.find((each) => each.availableSlots);
        if (date && date?.dateString) {
          setSelectedDate(date.dateString);
          date.workingDaySlots.slots.map((slot) => {
            let slotStartTime = slot.slotStartTime / 60;
            let slotEndTime = slot.slotEndTime / 60;
            let startTime =
              slotStartTime > 12
                ? (slotStartTime % 12) + ":00 PM"
                : slotStartTime == 12
                ? slotStartTime + ":00 PM"
                : slotStartTime + ":00 AM";
            let endTime =
              slotEndTime > 12
                ? (slotEndTime % 12) + ":00 PM"
                : slotEndTime == 12
                ? slotEndTime + ":00 PM"
                : slotEndTime + ":00 AM";
            slot.timeString = startTime + " - " + endTime;
          });
          setTimeSlots(date.workingDaySlots.slots);
        }
      }
    });
  };

  const checkout = () => {
    setLoading(true);
    let accessToken = localStorage.getItem("user_short_token");
    let providerId = parseInt(localStorage.getItem("selectedProviderId"));
    let url = URL.mb_wapi + "Labs/v2/CheckoutItems";
    const phleboDetails = JSON.parse(
      localStorage.getItem("user_details") ?? "{}",
    );
    let checkoutItems = cart.map((elem) => {
      return {
        additionalParams: {
            bookingSource: platform,
            bookingUrl: "phlebo.medibuddy.in",
            isUpsellOrder: true,
            parentOrderId: parentOrderDetails.orderId,
            phleboId: phleboDetails?.phleboId,
        },
        packageId: elem.packageId,
        packageName: elem.packageName,
        itemPrice: elem.price,
        contractType: elem.contractId,
        dateOfBirth: selectedBenef.dob,
        gender: selectedBenef.gender,
        isSponsored: false,
        maid: selectedBenef.maid,
        patientName: selectedBenef.name,
        relation: selectedBenef.relationName,
        visitType: "HomeVisit"
      };
    });
    let obj = {
        checkoutItems: checkoutItems,
        contactInfo: {
            addressLine1: addressLine1,
            addressLine2: addressLine2,
            city: city,
            email: email,
            pincode: pincode,
            phone: parentOrderDetails.phoneNumber ? parentOrderDetails.phoneNumber : phone
        },
        redirectionInfo: {
            RedirectToFailure: "orderFailure",
            RedirectToSuccess: "orderSuccess"
        },
        hvProviderInfo: {
          prefDateTime: orderDateTime,
          dcIds: [providerId],
        },
    };
    let headers = {
      Accesstoken: accessToken,
      Platform: platform,
      pincode: pincode,
      city: city,
    };

    axios.post(url, obj, { headers: headers }).then((response) => {
      if (response.data.isSuccess) {
        labsDetails.checkoutInfo = {
          ...obj,
          isRXRequired:
            selectedBenef.isRXRequired &&
            obj.checkoutItems.some((x) => x.contractType == 10389),
          isRXVerificationRequired: selectedBenef.isRXVerificationRequired,
          paymentOptions: response.data.paymentOptions,
          walletBalaceDetail: response.data.walletBalaceDetail,
          paymentLinkPhoneNumber: phone
        };

        history.push("/labs/payment");
      } else {
        alert(response.data.errorMessage);
      }
    }).catch ((error) => {
      alert("Something went wrong. Please try again");
    }).finally(() => {
      setLoading(false);
    });
  };

  const selectDate = (slot) => {
    setSelectedDate(slot.dateString);
    slot.workingDaySlots.slots.map((slot) => {
      let slotStartTime = slot.slotStartTime / 60;
      let slotEndTime = slot.slotEndTime / 60;
      let startTime =
        slotStartTime > 12
          ? (slotStartTime % 12) + ":00 PM"
          : slotStartTime == 12
          ? slotStartTime + ":00 PM"
          : slotStartTime + ":00 AM";
      let endTime =
        slotEndTime > 12
          ? (slotEndTime % 12) + ":00 PM"
          : slotEndTime == 12
          ? slotEndTime + ":00 PM"
          : slotEndTime + ":00 AM";
      slot.timeString = startTime + " - " + endTime;
    });
    setTimeSlots(slot.workingDaySlots.slots);
  };

  useEffect(() => {
    if (!parentOrderDetails.orderDateTime) {
      fetchProviderCalendar();
    }
  }, []);

  return (
    <div className="order-details-dashboard p-b-10">
      <div>
        <div className="header-sample">
          <i className="fa fa-chevron-circle-left" onClick={() => history.push('/packageSelection')}></i>
        </div>
        <DependantHeaderSample titleCall={true} noCall={true} title="Create Order"></DependantHeaderSample>
      </div>
      <Backdrop open={isLoading} sx={{ zIndex: 99999 }}>
				<CircularProgress />
			</Backdrop>
      <div>
        <Container className="p-t-10 p-b-10">
          <Row>
            <Col>
              <div className="font-size-smd">
                <b>Username:</b> {userName}
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="font-size-smd">
                <b>Relation:</b> {selectedBenef.relationName}
              </div>
              <div className="font-size-smd">
                <b>Name:</b> {selectedBenef.name}
              </div>
            </Col>
          </Row>
          <Form className="m-t-10">
            <Row>
              <Col xs={6} md={6}>
                <Form.Group className="mb-3" controlId="Pincode">
                  <Form.Control
                    type="text"
                    placeholder="Enter Pincode"
                    onChange={(e) => setPincode(e.target.value)}
                    value={pincode}
                    disabled={parentOrderDetails.pincode}
                  />
                </Form.Group>
              </Col>
              <Col xs={6} md={6}>
                <Form.Group className="mb-3" controlId="City">
                  <Form.Control
                    type="text"
                    placeholder="Enter City"
                    onChange={(e) => setCity(e.target.value)}
                    value={city}
                    disabled={parentOrderDetails.city}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className="mb-3" controlId="Pincode">
              <Form.Control
                type="text"
                placeholder="Enter Address Line 1*"
                onChange={(e) => setAddressLine1(e.target.value)}
                value={addressLine1}
                disabled={parentOrderDetails.addressLine1}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="City">
              <Form.Control
                type="text"
                placeholder="Enter Address Line 2*"
                onChange={(e) => setAddressLine2(e.target.value)}
                value={addressLine2}
                disabled={parentOrderDetails.addressLine2}
              />
            </Form.Group>
          </Form>

          <div className="card-box font-size-smd p-10 m-t-10 m-b-10" style={{ boxShadow: "2px 2px 4px 2px rgba(0, 0, 0, 0.2)" }}>
            <div className="font-size-md m-b-10">
              <b>Cart Items</b>
            </div>
            {cart.map((elem) => {
              return <div>{elem.packageName}</div>;
            })}
          </div>
          <div className="font-size-md bold">Date & Time</div>
          {parentOrderDetails.orderDateTime ? (
            <div className="font-size-smd">{parentOrderDetails.orderDateTime}</div>
          ) : (
            <div>
              <div style={{ overflowX: "auto", whiteSpace: "nowrap", padding: "5px" }}>
                <div style={{ display: "flex" }}>
                  {providerSlots && providerSlots.length ? (
                    providerSlots.map((slot) => (
                      <div
                        key={slot.dateString}
                        onClick={() => selectDate(slot)}
                        style={{
                          boxShadow: "0 0 5px rgb(24 24 24 / 32%)",
                          borderRadius: "5px",
                          minWidth: "100px",
                          marginRight: "10px",
                          padding: "5px",
                          color: slot.dateString === selectedDate ? "white" : "black",
                          backgroundColor: slot.dateString === selectedDate ? "#1778f2" : "white",
                        }}
                      >
                        <div className="font-size-smd">{slot.dateString}</div>
                        <div className="font-size-smd">{slot.workingDaySlots.dayOfWeek}</div>
                        <div
                          className="font-size-smd m-t-10"
                          style={{
                            backgroundColor: slot.availableSlots ? "#7cbb7c" : "#d19077",
                            color: "white",
                            textAlign: "center",
                            borderRadius: "5px",
                          }}
                        >
                          {slot.availableSlots ? "Available" : slot.noSlotReason}
                        </div>
                      </div>
                    ))
                  ) : (
                    <div>
                      <div className="font-size-smd">No Slots Available</div>
                    </div>
                  )}
                </div>
              </div>
              <Row style={{ margin: "5px" }}>
              {timeSlots && timeSlots.length ? (
                timeSlots.map((slot) => (
                  <div
                    onClick={() => setOrderDateTime(slot.slotStartDateTime)}
                    style={{
                      border: "1px solid #aaaaaa",
                      borderRadius: "5px",
                      minWidth: "140px",
                      marginRight: "10px",
                      padding: "5px",
                      color: slot.slotStartDateTime == orderDateTime ? "white" : "black",
                      backgroundColor: slot.slotStartDateTime === orderDateTime ? "#1778f2" : "white",
                    }}
                  >
                    <div className="font-size-smd">{slot.timeString}</div>
                  </div>
                ))
              ) : (
                <div>
                  <div className="font-size-md">No Slots Available</div>
                </div>
              )}</Row>
            </div>
          )}
          <div className="font-size-md bold">Enter Contact Details</div>
          <Form className="m-t-10">
            <Form.Group className="mb-3" controlId="Pincode">
              <Form.Control
                type="text"
                placeholder="Enter Email*"
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                disabled={parentOrderDetails.email}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="City">
              <Form.Control
                type="text"
                placeholder="Enter Phone Number*"
                onChange={(e) => setPhone(e.target.value)}
                value={phone}
              />
              <span className="font-size-sm" style={{color: "#007bff"}}>* If payment is required then payment link will be sent to this phone number</span>
            </Form.Group>
          </Form>
        </Container>
      </div>
      <Container>
        <div className="fixed-bottom p-l-15 p-r-15 p-t-5">
          <Row>
            <Col xs={12}>
              <Button
                disabled={!addressLine1 || !addressLine2 || !email || !phone || !orderDateTime}
                variant="primary"
                size="md"
                block
                className="border-curve-10"
                onClick={() => checkout()}
              >
                Checkout
              </Button>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default Checkout;
